export enum AuthRoutes {
  search = '/search',
  searchHistory = '/searchHistory',
  rules = '/rules',
  orderDetails = '/orderDetails',
  orders = '/orders',
  users = '/users',
  locations = '/locations',
  adminSearch = '/adminSearch'
}

export enum NonAuthRoutes {
  login = '/login',
  unathorized = '/',
}

export enum AdminRoutes {
  rules = '/rules',
  users = '/users',
  locations = '/locations',
  adminSearch = '/adminSearch'
}

export enum ExternalUserRoutes {
  search = '/search',
  searchHistory = '/searchHistory',
  orderDetails = '/orderDetails',
  orders = '/orders'
}

export enum userActionTypes{
  LOGIN_USER = 'LOGIN_USER',
  LOGOUT_USER = 'LOGOUT_USER',
  LOAD_USER = 'LOAD_USER',
  UPDATE_USER_LIST = 'UPDATE_USER_LIST'
}

export enum rulesActionTypes{
  ADD_RULE = 'ADD_RULE',
  DELETE_RULE = 'DELETE_RULE',
  LOAD_ALL = 'LOAD_ALL',
  CLEAR_RULE = 'CLEAR_RULE'
}

export enum KeyTypes {
  METAL = 'Metal',
  TRANSPONDER = 'Transponder',
  PROXIMITY = 'Proximity',
  SPECIAL_ORDER = 'Special Order',
  UNSUPPORTED = 'Unsupported'
}

export enum StringOperatorTypes {
  EQUALS = 'Exact Match',
  CONTAINS = 'Contains',
  STARTS_WITH = 'Starts With',
  ENDS_WITH = 'Ends With'
}

export enum NumberOperatorTypes {
  EQUALS = 'Equals',
  LESS_THAN = 'Less than',
  LESS_THAN_OR_EQUALS = 'Less than or Equals',
  GREATER_THAN = 'Greater than',
  GREATER_THAN_OR_EQUALS = 'Greater than or Equals'
}

export enum formActionTypes{
  VALIDATE_FIELD = 'VALIDATE_FIELD',
  VALIDATE_FORM = 'VALIDATE_FORM',
  FORM_VALUES = 'FORM_VALUES',
  SERVICE_ERROR = 'SERVICE_ERROR',
  CLEAR_ERRORS = 'CLEAR_ERRORS',
  CLEAR_FORM = 'CLEAR_FORM',
  REMOVE_ERROR = 'REMOVE_ERROR',
  ADD_ERROR = 'ADD_ERROR'
}

export enum cartActionTypes {
  ADD_ITEM = 'ADD_ITEM',
  RESET_CART = 'RESET_CART',
  CHECKOUT_CART = 'CHECKOUT_CART',
  REFRESH_COUNT = 'REFRESH_COUNT',
  TOGGLE_CART = 'TOGGLE_CART',
  LOAD_CART = 'LOAD_CART',
  UPDATE_CART_ITEM = 'UPDATE_CART_ITEM'
}

export enum cartItemActionTypes {
  ADD_ITEM_QUANTITY = 'ADD_ITEM_QUANTITY',
  SUBTRACT_ITEM_QUANTITY = 'SUBTRACT_ITEM_QUANTITY',
  UPDATE_ITEM_QUANTITY = 'UPDATE_ITEM_QUANTITY',
  DESELECT_ITEM = 'DESELECT_ITEM',
  UPDATE_CART_ITEM_VEHICLE = 'UPDATE_CART_ITEM_VEHICLE'
}
export enum orderActionTypes {
  LOAD_ORDER = 'LOAD_ORDER',
  LOAD_SEARCH_INFO = 'LOAD_SEARCH_INFO',
  LOAD_ORDER_LIST = 'LOAD_ORDER_LIST'
}

export enum searchActionTypes {
  LOAD_SEARCH_LIST = 'LOAD_SEARCH_LIST',
  LOAD_ORDER = 'LOAD_ORDER',
  LOAD_ORDER_MAP = 'LOAD_ORDER_MAP',
  SHOW_ADD_TO_CART = 'SHOW_ADD_TO_CART',
  HIDE_ADD_TO_CART = 'HIDE_ADD_TO_CART',
  LOAD_OPTIONAL_ITEMS_MAP = 'LOAD_OPTIONAL_ITEMS_MAP',
  ADD_TO_OPTIONAL_ITEMS_MAP = 'ADD_TO_OPTIONAL_ITEMS_MAP'
}

export enum userTypes{
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

export enum userTypesString{
  INTERNAL = 'Internal',
  EXTERNAL = 'External'
}

export enum OrderStatus {
  SUBMITTED = 'Submitted', 
  ACCEPTED = 'Accepted', 
  REJECTED = 'Rejected', 
  COMPLETED = 'Completed'
}

export enum themes {
  DEFAULT = 'DEFAULT',
  MANHEIM = 'MANHEIM',
  CARVANA = 'CARVANA'
}

export enum MatcherType {
  MAKE = 'MAKE',
  MODEL = 'MODEL',
  YEAR = 'YEAR',
  COMPANY = 'COMPANY',
}

export enum MatcherOperator {
  EQUALS = 'EQUALS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  CONTAINS = 'CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
}